<h2>C-WORLD</h2>

<div class="cw-color-orange cw-login-error">
  <!-- Show only the whitespace error if it exists, otherwise show the login error -->
  <span [hidden]="!(loginError || whitespaceInUsername)">
    {{ (whitespaceInUsername ? 'GLOBAL.LOGIN.LOGINERROR.WHITESPACEINUSERNAME' : 'GLOBAL.LOGIN.LOGINERROR.' + loginErrorTranslation) | translate }}
  </span>
</div>

<!-- Variable "loginForm" ist Referenz auf ngForm-Direktive -->
<form [formGroup]="form" (submit)="clickLogin()">
  <div class="form-group">
    <span class="icon-user cw-login-icon"></span>
    <input
      formControlName="username"
      name="username"
      type="text"
      class="form-control cw-login-input"
      placeholder="{{ 'GENERAL.USERNAME' | translate }}"/>
  </div>
  <div class="form-group">
    <span class="icon-lock cw-login-icon"></span>
    <div class="cw-password-wrapper">
      <input
        formControlName="password"
        name="password"
        [type]="showPassword ? 'text' : 'password'"
        class="form-control cw-login-input"
        placeholder="{{ 'GENERAL.PASSWORD' | translate }}"
        autocomplete="nope"/>
      <button type="button" class="cw-password-toggle" (click)="showPassword = !showPassword" tabindex="-1">
        <fa-icon [icon]="showPassword ? 'eye-slash' : 'eye'"></fa-icon>
      </button>
    </div>
  </div>

  <button mat-raised-button color="accent" type="submit" class="cw-login-button" [disabled]="!form.valid || loading || whitespaceInUsername">
    {{ 'GENERAL.LOGIN' | translate }}
  </button>
  <p><span [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></span>&nbsp;</p>
</form>

@if (ssoConfig['tenant_id']) {
  <form
    [formGroup]="form"
    (ngSubmit)="clickLoginMicrosoft()">
    <button mat-raised-button type="submit" class="cw-login-button" [disabled]="loading">
      <div class="image-container">
        <img src="./assets/img/logos/microsoft-login.svg" alt="Microsoft Logo" />
        <span>Bei Microsoft anmelden</span>
      </div>
    </button>
  </form>
}

@if (passwordForgotLink) {
  <div class="cw-login-forgot">
    <a href="{{ passwordForgotLink }}" target="_blank">{{ 'GLOBAL.LOGIN.PASSWORDFORGOT' | translate }}</a>
  </div>
}
